<template>
  <div>
    <div class="BlockList">
      <div class="BlockList-W" v-show="flag">
        <div class="sign_close">
          <img src="../../../assets/pc/Logo/left1.png" @click="gotoblack" />
          <img src="../../../assets/pc/Logo/close.png" @click="close" />
        </div>
        <div class="signbox">
          <div class="sign_tit1">Reset password</div>

          <div class="sign_form">
            <el-form ref="form" :model="form" :rules="rules">
              <div class="putext">
                <div class="puttit">Email</div>
                <el-form-item prop="email">
                  <el-input
                    v-model="form.email"
                    class="inpttext"
                    placeholder="Enter your email address"
                  ></el-input>
                </el-form-item>
              </div>
              <div class="putext" style="margin-top: 30px;">
                <div class="puttit">Verificaton Code</div>
                <el-form-item prop="vertificationCode">
                  <div
                    style="
                      display: flex;
                      background: #000000;
                      border-radius: 12px 12px 12px 12px;
                      opacity: 1;
                    "
                  >
                    <el-input
                      v-model="form.vertificationCode"
                      class="inpttext"
                      style="width: 290px !important; padding-right: 0px"
                      placeholder="Enter the verification code in email"
                    ></el-input>
                    <div
                      style="
                        border-right: 1px solid #7f8081;
                        height: 26px;
                        margin-top: 8px;
                        width: 1px;
                      "
                    ></div>
                    <div
                      style="
                        width: 60px;
                        text-align: center;
                        color: #b3b3b3;
                        cursor: pointer;
                      "
                      @click="startCountdown"
                      :disabled="countdown > 0"
                    >
                      {{ countdown > 0 ? countdown + "s" : "Send" }}
                    </div>
                  </div>
                  <!-- <el-input v-model="form.email" class="inpttext"></el-input> -->
                </el-form-item>
              </div>

              <div class="putext" style="margin-top: 30px;">
                <div class="puttit">Set a new password</div>
                <el-form-item prop="password">
                  <el-input
                    type="password"
                    v-model="form.password"
                    class="inpttext"
                    show-password
                    placeholder="Enter your new password"
                  ></el-input>
                </el-form-item>
              </div>
              <div class="putext" style="margin-top: 30px;">
                <div class="puttit">Confirm the password</div>
                <el-form-item prop="repassword">
                  <el-input
                    type="password"
                    v-model="form.repassword"
                    class="inpttext"
                    show-password
                    placeholder="Enter the new password again"
                  ></el-input>
                </el-form-item>
              </div>
              <div
              style="margin-top: 30px;"
                class="submit"
                :class="{ submit1: isFormValid() }"
                @click="submit"
              >
                Reset password
              </div>
              <div class="tit1">
                I didn't receive the email verifcation code what should I do?
              </div>
              <div class="tit2">
                <span> 1.</span> The email might be lost due to network
                connection error, Pleaseresend a verifcation code or try again
                lateir.
              </div>
              <div class="tit2">
                <span>2.</span> Please make sure you email address is still in
                use and check the Spamfolder.
              </div>
            </el-form>
          </div>
        </div>
      </div>
      <div class="BlockList-Ws" v-show="flags">
        <div class="blockbox">
          <img src="../../../assets/pc/Logo/succ.png" />
          <div class="blocktit">Password Changed Successfully</div>
          <div class="blockgo">
            <div @click="gotologin">Go to sign ln</div>

            <img src="../../../assets/pc/Logo/left.png" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { resetPwd, sendResetPwdEmail } from "@/assets/server/api";
export default {
  props: ["flogc", "floag"],
  data() {
    return {
      form: {},
      rules: {},
      sendtrue: false,
      flag: this.flogc,
      flags: false,
      countdown: 0,
      form: {
        email: "",
        password: "",
        repassword: "",
        vertificationCode: "",
      },
      rules: {
        email: [
          {
            required: true,
            message: "email  is required",
            trigger: "change",
          },
          {
            type: "email",
            message: "Please enter a valid email address",
            trigger: ["blur", "change"],
          },
        ],
        vertificationCode: [
          {
            required: true,
            message: "vertificationCode  is required",
            trigger: "change",
          },
        ],
        password: [
          {
            required: true,
            message: "password  is required",
            trigger: "change",
          },
          {
            min: 6,
            max: 12,
            message: "Please enter a password between 6 and 12 characters.",
            trigger: "blur",
          },
        ],
        repassword: [
          {
            required: true,
            message: "repassword  is required",
            trigger: "change",
          },
          {
            min: 6,
            max: 12,
            message: "Please enter a password between 6 and 12 characters.",
            trigger: "blur",
          },
        ],
      },
    };
  },
  watch: {
    deep: true,
    flogc(val) {
      this.flag = val;
      console.log(this.flog);
      this.$refs.form.clearValidate();
      this.form.email = "";
      this.form.password = "";
      this.form.repassword = "";
      this.form.vertificationCode="";
    },
  },
  components: {},
  created() {},
  mounted() {},
  methods: {
    startCountdown() {
      this.send();
      this.$refs.form.clearValidate();
     
    },
    isFormValid() {
    
      // Check if all required fields have values
      return (
        this.form.email.trim() !== "" &&
        this.form.password.trim() !== "" &&
        this.form.repassword.trim() !== "" &&
        this.form.vertificationCode.trim() !== ""
        
      );
    },
    gotoblack() {
      this.flag = false;
      this.$emit("back", this.flag);
      this.$refs.form.clearValidate();
    },
    close() {
      this.flag = false;
      this.form.email = "";
      this.form.password = "";
      this.form.repassword = "";
      this.$refs.form.clearValidate();
      this.$emit("repwd", this.flag);
    },
    async send() {
      console.log("点击发送邮件");
      if (this.form.email !== "") {
        const params = {
          email: this.form.email,
        };
        const formData = new FormData();
        const item = params;
        for (const key in item) {
          if (Object.hasOwnProperty.call(item, key)) {
            formData.append(key, item[key]);
          }
        }
        let data = await sendResetPwdEmail(formData);
        console.log(data);
        if (data.code == 200) {
          this.$refs.form.clearValidate();
          this.flog1 = true;
          this.flog = false;
          this.emails = data.result;
       
          if (this.countdown === 0) {
          // Start the countdown only if it's not already running
          this.countdown = 60;
          this.countdownTimer = setInterval(() => {
            if (this.countdown > 0) {
              this.countdown--;
            } else {
              clearInterval(this.countdownTimer);
            }
          }, 1000);

          // Simulate sending the verification code
          //
        }
          this.sendtrue = true;
        } else if (data.code == 400) {
          this.countdown = 0;
          this.sendtrue = false;
          this.$message(data.result);
          this.$refs.form.clearValidate();
        }
      } else {
        this.$message(" This email are not filled in ");
        this.$refs.form.clearValidate();
        return false;
      }
    },
    async submit() {
      if (this.form.password !== this.form.repassword) {
        this.$message(" Passwords do not match ");
        return false;
      }
      this.$refs.form.validate(async (success) => {
        console.log(this.form);
        if (success) {
          const params = {
            email: this.form.email,
            password: this.form.password,
            vertificationCode: this.form.vertificationCode,
          };
          const formData = new FormData();
          const item = params;
          for (const key in item) {
            if (Object.hasOwnProperty.call(item, key)) {
              formData.append(key, item[key]);
            }
          }
          let data = await resetPwd(formData);
          console.log(data);
          if (data.code == 200) {
            this.$refs.form.clearValidate();
            this.flags = true;
            this.flag = false;
            this.emails = data.result;
           
          } else if (data.code == 400) {
            this.$message(data.result);
            this.$refs.form.clearValidate();
          }
        } else {
          this.$message(" This field are not filled in ");
          return false;
        }
      });
    },
    gotologin() {
      this.flags = false;
      this.$emit("back");
      this.form.email = "";
      this.form.password = "";
      this.form.repassword = "";
      this.form.vertificationCode = "";
      this.$refs.form.clearValidate();
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.el-message{
  z-index: 99999999999;
  background-color:#fff !important;
  /* 设置文本颜色为白色 */
  color: white !important;
  /* 其他样式调整，根据需要自行添加 */
}
/deep/.el-input__inner {
  color: #ffffff !important;
}
/deep/.el-input__inner::placeholder {
  color: rgba(255, 255, 255, 0.5) !important;
}
.BlockList {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  // height: 1000px !important;
  background: rgba(0, 0, 0, 0.7);
  width: 100%;
  height: 100%;
  overflow: auto;
  .BlockList-W {
    width: 630px;
    // border: 1px solid red;
    height: 1318px;
    background: #13161b;
    border-radius: 24px 24px 24px 24px;
    opacity: 1;
    position: absolute;
    // border: 1px solid red;
    left: 50%;
    top: 40%;
    transform: translate(-50%, -40%);
    margin-top: 120px;
    .sign_close {
      display: flex;
      justify-content: space-between;
      // margin-top: 18px;
      img {
        width: 48px;
        height: 48px;
        margin: 24px;
      }
    }
    .signbox {
      width: 550px;
      margin: 0 auto;
      margin-top: 16px !important;

      .sign_tit1 {
        height: 42px;
        font-size: 36px;
        font-family: Roboto, Roboto;
        font-weight: 500;
        color: #ffffff;
        line-height: 42px;
        text-align: center;
      }

      .sign_form {
        padding-top: 36px;
        .putext {
          margin-bottom: 46px;
          .puttit {
            height: 33px;
            font-size: 28px;
            font-family: Roboto, Roboto;
            font-weight: 500;
            color: rgba(255, 255, 255, 0.5);
            line-height: 33px;
            margin-bottom: 12px;
          }
          .inpttext {
            width: 550px;
            height: 80px;
            background: #000000;
            border-radius: 12px 12px 12px 12px;
            opacity: 1;
            border: 1px solid #000000;
            display: flex;
            /deep/.el-form-item__content {
              display: flex !important;
            }
            /deep/ .el-input__inner {
              background: #000000;
              border: none;
              // border: 1px solid red;
              font-size: 26px;
              font-family: Roboto, Roboto;
              font-weight: 400;
              color: #808080;
              word-spacing: -4px;
              padding-left: 15px !important;
              padding-right: 8px;
            }
          }
        }
        .submit {
          width: 550px;
          height: 80px;
          line-height: 80px;
          background: #333b3b;
          border-radius: 12px 12px 12px 12px;
          opacity: 1;
          text-align: center;
          font-size: 28px;
          font-family: Roboto, Roboto;
          font-weight: 500;
          color: #858989;
          cursor: pointer;
          margin-top: -8px;
        }
        .submit1 {
          background: rgba(0, 231, 154, 0.9);
          height: 80px;
          line-height: 80px;

          border-radius: 12px 12px 12px 12px;
          opacity: 1;
          text-align: center;
          font-size: 28px;
          font-family: Roboto, Roboto;
          font-weight: 500;
          color: #13161b;
        }
      }
    }
    .tit1 {
      height: 68px;
      font-size: 26px;
      font-family: Roboto, Roboto;
      font-weight: 400;
      color: #ffffff;
      line-height: 34px;
      margin-top: 20px;
      word-spacing: -4px;
    }
    .tit2 {
      margin-top: 18px;
      font-size: 24px;
      font-family: Roboto, Roboto;
      font-weight: 400;
      color: #808080;
      line-height: 34px;
      span {
        color: #fff !important;
      }
    }
  }
  .BlockList-Ws {
    width: 587px;
    height: 389px;
    background: #0b0c0f;
    border-radius: 20px 20px 20px 20px;
    opacity: 1;
    margin: 0 auto;
    position: absolute;
    // border: 1px solid red;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    .blockbox {
      margin: 63px 63px;
      img {
        width: 86px;
        height: 86px;
        margin-left: 187px;
        margin-top: 5px;
      }
      .blocktit {
        margin-top: 31px;
        width: 461px;
        height: 90px;
        font-size: 38px;
        font-family: Roboto, Roboto;
        font-weight: 500;
        color: #00e79a;
        line-height: 45px;
        text-align: center;
      }
      .blockgo {
        display: flex;
        margin-top: 30px;
        cursor: pointer;
        position: absolute;
        left: 50%;
        transform: translate(-50%,0);
        // span {
        //   font-size: 15px;
        //   font-family: Roboto, Roboto;
        //   font-weight: 400;
        //   color: #ffffff;
        // }
        div {
          height: 21px;
          font-size: 24px;
          font-family: Roboto, Roboto;
          font-weight: 400;
          color: #ffffff;
          line-height: 21px;
        //  margin-left: 127px;
        }
        img {
          width: 32px;
          height: 32px;
          margin-left: 2px;
          margin-top: -3px;
        }
      }
    }
  }
}
</style>
